module.exports = __webpack_public_path__ + "img/img_right@3x.0cf7f930.png";